/* 倒计时 */
window.getLocalTime = function(i) {
    if (typeof i !== "number") return;
    var d = new Date();
    var len = d.getTime();
    var offset = d.getTimezoneOffset() * 60000;
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
};

var flashStatus = "over";

window.initActivityClock = function(start, end, parentElement, callback) {
    /* flashStatus:秒杀状态
'before','after','overx
*/

    var flashStatus = "over";

    var _parent = jQuery(parentElement);
    var _element = _parent.find(".activity-clock_time");
    console.log(_parent, _element);

    var now_time = new Date();

    var startTime = new Date(start).getTime() - new Date().getTime(); //总的时间（毫秒）

    var endTime = new Date(end).getTime() - new Date().getTime(); //总的时间（毫秒）

    var clockTime = "";

    var tips = "End";
    if (startTime > 0) {
        tips = "From start";
        clockTime = startTime;
        flashStatus = "before";
    } else if (endTime > 0) {
        tips = "";
        clockTime = endTime;
        flashStatus = "after";
    } else {
        flashStatus = "over";
        _parent.find(".activity-clock_title").text(tips);
        _parent.find(".activity-clock_list").hide();
        // clearTimeout(activity_clock);
        callback(flashStatus);
        return false;
    }

    callback(flashStatus);

    _parent.find(".activity-clock_title").text(tips);
    // console.log('11111111', jQuery(".activity-clock_title").text())

    var timeString = getClockString(clockTime);

    var timeArr = timeString.split("");

    _element.each(function(inx, item) {
        jQuery(item).html(timeArr[inx]);
    });

    window.activity_clock = setTimeout(function() {
        initActivityClock(start, end, parentElement, callback);
    }, 1000);
};


initActivityClock('2023/12/13 14:00:00', '2023/12/14 13:59:59', jQuery('.seckill-clock'), function() {

    /* flashStatus:秒杀状态
        'before','after','over
    */
    switch (flashStatus) {
        case "before":


            break;
        case "after":


            break;
        case "over":



            break;
        default:
            break;
    }


});


/*end 倒计时 */


function getClockString(clockTime) {
    var haoscend = clockTime % 1000; //毫秒

    //console.log(haoscend);
    var scend = fillZero(parseInt((clockTime / 1000) % 60)); //秒
    //console.log(scend);
    var minute = fillZero(parseInt((clockTime / 1000 / 60) % 60)); //  分钟
    // console.log(minute);
    // var hour = fillZero(parseInt((clockTime / 1000 / 60 / 60) % 24)); //小时
    var hour = fillZero(parseInt((clockTime / 1000 / 60 / 60))); //天数*小时
    // console.log(hour);
    // var day = fillZero(parseInt((clockTime / 1000 / 60 / 60 / 24) % 30)); //天数
    // console.log(day);
    // var month = fillZero(parseInt((alltime / 1000 / 60 / 60 / 24 / 30) % 12)); //月
    // console.log(month);

    var timeString = hour + minute + scend;

    // var timeString = day + hour + minute + scend;
    return timeString;
}

function fillZero(number) {
    return number < 10 ? "0" + number : "" + number;
}

$(function(){
    $('.floor li:first').addClass('active');
    //第一种点击li元素到相应的楼层的方法，锚点要去掉  
    var flag = true //设置标识。防止出现跑马灯   
    $(window).scroll(function () {
          var _scrollH = $(this).scrollTop();
          var scoll_top = $(".banner").height()-$(".Header__Wrapper").height();
          // var scoll_top = $(".banner").height()-100;
          if(_scrollH > scoll_top){
              $('.module_tab').css('position','fixed');
              $('.module_tab').css('left','0');
              $('.module_tab').css('right','0');
              $('.module_tab').css('top',$("#section-header").height());
          }else{
              $('.module_tab').css('position','sticky');
          }
    })
        // 滚动时动态更新active类
        $(window).on('scroll', function() {
            var scrollPosition = $(window).scrollTop();
    
            $('.blackFriday_cen').each(function() {
                if(jQuery(window).width()<=768){
                    var sectionTop = $(this).offset().top - $(".Header__Wrapper").height() - $(".module_tab").height() - 20;
                }else{
                    var sectionTop = $(this).offset().top - $(".Header__Wrapper").height() - $(".module_tab").height() - 80;
                }
                var sectionBottom = sectionTop + $(this).outerHeight();
                // 判断当前滚动位置是否在该section的范围内
                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    var currentId = '#' + $(this).attr('id');
                    $('.module_tab_word').removeClass('active');
                    $('a[href="' + currentId + '"]').parent().addClass('active').siblings().removeClass('active');
                }
            });
        });

        $(".floor li").click(function(event){ 
            console.log('开始点击',event,$(this));
            $('.module_tab_word').removeClass('active');
            event.preventDefault();
            $(this).addClass("active");
            $(this).siblings().removeClass("active");
            // 获取目标锚点的ID
            var targetId = $(this).find("a").attr('href');
    
            // 使用动画平滑滚动到锚点位置
            // $('html, body').animate({
            //     scrollTop: $(targetId).offset().top-$("#section-header").height()-$(".module_tab").height()
            // }, 800); // 800 是滚动的时间，单位为毫秒
            console.log('点击',$(this),$(this).index());
            flag = false  
            var index = $(this).index();//获取当前点击元素的索引  
            if(index==1){
                console.log('点击的第二个按钮');
                // $(".module_tab_cen").eq(0).removeClass('active');
                // $(".module_tab_cen").eq(2).removeClass('active');
                $(".module_tab_cen .module_tab_word").eq(1).addClass('active');
                        // 使用动画平滑滚动到锚点位置
                        // $('html, body').animate({
                        //     scrollTop: $(targetId).offset().top-$("#section-header").height()-$(".module_tab").height()
                        // }, 800); // 800 是滚动的时间，单位为毫秒
                // 使用动画平滑滚动到锚点位置
                if(jQuery(window).width()<=768){
                    $('html, body').animate({
                        scrollTop: $(targetId).offset().top-$("#section-header").height()-$(".module_tab").height()
                    }, 800); // 800 是滚动的时间，单位为毫秒
                }
                if(jQuery(window).width()>769){
                    $('html, body').animate({
                        scrollTop: $(targetId).offset().top-$("#section-header").height()-$(".module_tab").height()
                    }, 800); // 800 是滚动的时间，单位为毫秒
                }
            }else{
                // 使用动画平滑滚动到锚点位置
                if(index==2){
                    $('html, body').animate({
                        scrollTop: $(targetId).offset().top-$("#section-header").height()-$(".module_tab").height() + 10
                    }, 800); // 800 是滚动的时间，单位为毫秒
                }else{
                    $('html, body').animate({
                        scrollTop: $(targetId).offset().top-$("#section-header").height()-$(".module_tab").height()
                    }, 800); // 800 是滚动的时间，单位为毫秒
                }
            }
        }) 
})